import { z } from 'zod'

import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

const dental_previous_coverage = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath(
        'previous_insurance_covers_min_75_percent_dental_replacements'
      )]: z.boolean(),
    }),
    showOrderSummary: true,
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_dental:steps.dental_previous_coverage.title',
        },
      },
      {
        type: 'text',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_dental:steps.dental_previous_coverage.subtitle',
        },
        style: 'body2',
        color: 'grey500',
      },
      {
        type: 'yesNo',
        variant: 'filled',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath(
          'previous_insurance_covers_min_75_percent_dental_replacements'
        ),
      },
    ],
    subFlow: SubFlow.Dental,
    nextStepConfig: {
      valuePath: params.helperFunctions.getParamPath(
        'previous_insurance_covers_min_75_percent_dental_replacements'
      ),
      valueToStepName: {
        true: 'dental_previous_reimbursement',
        false: 'dental_previous_coverage_breakdown',
      },
    },
  }) as const satisfies AnyStepConfiguration

export default dental_previous_coverage
